import { NetworkType, Log } from "../dependencies";

const LOGTAG = "NetworkDetector";

declare interface NetworkUpdateCallback {
    (network: NetworkType): void;
}

declare interface LGNetworkEvent extends Event {
    detail: {
        state: string;
    };
}

declare interface NetworkInformation extends EventTarget {
    type?: string;
}

declare interface ConnectionNavigator {
    connection?: NetworkInformation;
}

class NetworkDetectorImpl {
    private networkTypeMap: Map<string, NetworkType> = new Map<string, NetworkType>([
        // LG
        ["Ethernet", NetworkType.ETHERNET],
        ["5GHz_WiFi", NetworkType.WIFI_5_0],
        ["2.4GHz_WiFi", NetworkType.WIFI_2_4],
        ["Others", NetworkType.OTHER],
        ["disconnected", NetworkType.UNKNOWN],
        // NetworkInformation
        ["wifi", NetworkType.WIFI],
        ["ethernet", NetworkType.ETHERNET],
        ["none", NetworkType.UNKNOWN],
        ["bluetooth", NetworkType.BLUETOOTH],
        ["wimax", NetworkType.WIMAX],
        ["other", NetworkType.OTHER],
        ["mobile", NetworkType.MOBILE],
        ["unknown", NetworkType.UNKNOWN]
    ]);
    private network: NetworkType = NetworkType.UNKNOWN;
    private networkUpdateCallbacks: NetworkUpdateCallback[] = [];

    constructor() {
        window.addEventListener("GFNNetworkInfo", (evt: Event) => {
            const e = evt as LGNetworkEvent;
            Log.d("{aac1655}", "{2925c9d}", e.detail.state);
            this.updateNetwork(e.detail.state);
        });
        const connection = (navigator as ConnectionNavigator).connection;
        // only set the network type if we can get the real connection information
        if (connection?.type) {
            this.updateNetwork(connection.type);
            connection.addEventListener("change", (e: Event) => {
                const networkType = (navigator as ConnectionNavigator).connection?.type;
                if (networkType) {
                    Log.d("{aac1655}", "{4a9e05b}", networkType);
                    this.updateNetwork(networkType);
                }
            });
        }
    }

    // Invoke callbacks to update network status
    private updateNetwork(net: string) {
        const networkType = this.networkTypeMap.get(net);
        if (networkType) {
            this.network = networkType;
            for (const callback of this.networkUpdateCallbacks) {
                callback(this.getNetworkType());
            }
        } else {
            Log.d("{aac1655}", "{1e3c13d}", net);
        }
    }

    public registerNetworkCallback(callback: NetworkUpdateCallback) {
        this.networkUpdateCallbacks.push(callback);
    }

    public unregisterNetworkCallback(callback: NetworkUpdateCallback) {
        const idx = this.networkUpdateCallbacks.findIndex(e => e == callback);
        if (idx !== -1) {
            this.networkUpdateCallbacks.splice(idx, 1);
        }
    }

    public getNetworkType(): NetworkType {
        return this.network;
    }
}

export const NetworkDetector = new NetworkDetectorImpl();
